import React from 'react';
import { Search, X } from 'lucide-react';

const SearchMenu = ({ searchTerm, onSearchChange, isCollapsed, autoFocus = false, className = '' }) => {
  const inputRef = React.useRef(null);

  React.useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  // Global Ctrl+K / Cmd+K shortcut listener
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        if (inputRef.current) {
          inputRef.current.focus();
          inputRef.current.select();
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  if (isCollapsed) return null;

  return (
    <div className={`relative w-full ${className}`}>
      <div className="relative flex items-center">
        <Search className="absolute left-2.5 h-3.5 w-3.5 text-[#64748B] pointer-events-none stroke-[2]" />
        <input
          ref={inputRef}
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Find a page..."
          maxLength={90}
          className="w-full h-8 pl-8 pr-14 bg-white border border-[#E5E7EB] rounded-[10px] text-xs text-[#1E293B] placeholder-[#94A3B8] transition-all duration-150 ease-in-out focus:outline-none focus:border-[#0F2942] focus:ring-1 focus:ring-[#0F2942]/15 shadow-xs"
        />
        {searchTerm ? (
          <button
            type="button"
            onClick={() => onSearchChange('')}
            className="absolute right-2.5 p-0.5 rounded-full text-[#64748B] hover:text-[#1E293B] hover:bg-gray-100 transition-colors cursor-pointer"
            title="Clear search text"
          >
            <X className="h-3 w-3 stroke-[2]" />
          </button>
        ) : (
          <div className="absolute right-2.5 flex items-center pointer-events-none">
            <kbd className="text-[10px] font-medium text-slate-400 bg-white border border-slate-200 px-1.5 py-0.5 rounded-md shadow-2xs">Ctrl K</kbd>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchMenu;
